// extracted by mini-css-extract-plugin
export default {"root":"BundleFeature-root","text":"BundleFeature-text","text--disabled":"BundleFeature-text--disabled","icon":"BundleFeature-icon","newLabel":"BundleFeature-newLabel"};